<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    app
    width="260"
    color="#263238"
    v-bind="$attrs"
  >
    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <v-list-item>
        <v-img
          :src="logo"
          width="100"
          height="50"
        />
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>
    </v-list>
    <div>
      <v-btn
        class="my-logout-button-style"
        text
        @click="logOut()"
      >
        <v-icon
          left
        >
          mdi-logout
        </v-icon>
        Logout
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script>
  import drawerItems from 'src/data/drawer-items';

  // Utilities
  import {
    mapState,
  } from 'vuex';

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      items: [],
      logo: require('@/assets/DBSLogo.png'),
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer;
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val);
        },
      },
      computedItems () {
        return this.items.map(this.mapItem);
      },
      profile () {
        return {
          avatar: true,
          title: 'DBS',
        };
      },
    },

    mounted () {
      this.setDrawerItems();
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        };
      },
      setDrawerItems () {
        this.items = drawerItems;
      },
      logOut () {
        this.$store.dispatch('adminuser/logout');
      },
    },
  };
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'
  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
<style scoped>
.my-logout-button-style {
  font-size: 13px;
   margin: 0 ;
   bottom:0;
   left:0;
   right:0;
   position:absolute;
  text-align: center;
  display: block;
}
</style>
